import store from "@/config/vuex/store";

export default [
    {
        path: "/usuarios",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "cadastrar",
                name: "usuarioCreate",
                component: () => import('@/pages/Usuario/UsuarioCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "usuarioUpdate",
                component: () => import('@/pages/Usuario/UsuarioUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "/",
                name: "usuarioRead",
                component: () => import('@/pages/Usuario/UsuarioRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "visualizar/:id",
                name: "usuarioView",
                component: () => import('@/pages/Usuario/UsuarioView'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "niveis-acesso/:id",
                name: "usuarioReadNiveisAcesso",
                component: () => import('@/pages/Usuario/UsuarioReadNiveisAcesso'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "empresas/:id",
                name: "usuarioReadEmpresa",
                component: () => import('@/pages/Usuario/UsuarioReadEmpresa'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "perfil/:id",
                name: "usuarioUpdatePerfil",
                component: () => import('@/pages/Usuario/UsuarioUpdatePerfil'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "vendedores",
                name: "usuarioVendedorRead",
                component: () => import('@/pages/Usuario/UsuarioVendedorRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

